import {
  FocusTrapZone,
  ICommandBarItemProps,
  PrimaryButton,
  Stack,
} from "@fluentui/react";
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import { CustomCommandBar } from "../../components/Generic/customCommandBar";
import HeaderGeneric from "../../components/Generic/headerPanel";
import { fetchIdentidad, urlTelerik } from "../../services/http-common";
import { IconHelper } from "../../utils/Helper/iconHelper";
import ThemeBase from "../../utils/Theme/themeBase";
import TokenService from "../../services/TokenService";
import { useEffect, useRef, useState } from "react";
import TablaReporte from "../../components/Table/TableReporte";
import { IExportarReporte } from "../../interfaces/base/IBase";
import reporteServicio from "../../services/reporteService";
import AuthService from "../../services/AuthService";
import { keyAccess, keyJwt } from "../../utils/Helper/helper";
import CuadroMandoGenerico from "../../components/Generic/CuadroMandoTelerik";

const NameReport = "MOVCuadroMandoTrasporte.trdx";

const CuadroMandoTransporte = () => {
  let t = TokenService.getToken();
  // const viewerRef = useRef(); //equivalnete id de componente
  const viewerRef = useRef(null);
  const _rigthBar = () => {
    const _items: ICommandBarItemProps[] = [
      {
        ...IconHelper.ICON_INFO,
        // onClick: ,
      },
    ];
    return _items;
  };

  const [key, setKey] = useState(0);
  
  const recargarComponente = () => {
    setKey(prevKey => prevKey + 1);
  };

  function descargarReporte() {
    const reporteExportar: IExportarReporte = {
      report: NameReport,
      Extension: "PDF"
    }

    reporteServicio.exportaReporte(reporteExportar)

      .then((response) => {
        if (response.status === 401 || response.status === 403) {
          localStorage.removeItem(keyAccess);
          AuthService.removeToken();
          window.location.assign("/login");
        }
        if (response.status === 200) {
          const dataUrl = response.data;

          const link = document.createElement('a');
          link.href = dataUrl;
          link.download = NameReport.split('.')[0] + '.pdf';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

        }
        else {
          console.error("Status:", response.status);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const _items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      onClick: recargarComponente,
    }
  ];

  const _farItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_PDF,
      onClick: () => {
        descargarReporte();
      },
    },
  ];

  return (
    <>
      <div className="ms-Grid" dir="ltr">
        <br />
        <div className="ms-Grid-row">
          <div style={{paddingLeft: "10px"}}>
            <TablaReporte
              title={"Cuadro Mando Transporte"}
              subTitle={"Gestión transporte"}
              rigthBar={_farItems}
              leftBar={_items}
              horizontalAlign="start"
              iconName="BarChartVerticalFill"
            />
          </div>
          </div>
        <br />
      </div>

       <div key={key}>
        <CuadroMandoGenerico
          NameReport={NameReport}
          parameters={{}}  // Pasando los parámetros como props
          scaleMode="FIT_PAGE_WIDTH"
        />
      </div>
    </>
  );
};

export default CuadroMandoTransporte;
